'use strict';

var utils = require('./utils.js');
var constants = require('./constants.js');
var light = require('./light.js');
var lightUplift = require('./light-uplift.js');

var metaThemePartials = {
  light: light.metaThemeLightPartial,
  'Polaris-Summer-Editions-2023': lightUplift.metaThemeLightUpliftPartial
};
var metaThemeDefaultPartial = metaThemePartials[constants.themeNameDefault];
var metaThemeDefault = utils.createMetaTheme(metaThemeDefaultPartial);

exports.createMetaTheme = utils.createMetaTheme;
exports.metaThemeDefault = metaThemeDefault;
exports.metaThemeDefaultPartial = metaThemeDefaultPartial;
exports.metaThemePartials = metaThemePartials;
